import { type EventContentArg } from "@fullcalendar/core"
import React from "react"

import { CalendarEventCellEvent } from "./CalendarEventCellEvent.tsx"
import { CalendarEventCellReminder } from "./CalendarEventCellReminder.tsx"

export function CalendarEventCell(eventInfo: EventContentArg) {
  const isReminder = eventInfo?.event?.extendedProps?.type === "reminder"

  return (
    <div className={`size-full overflow-hidden`}>
      {isReminder ? (
        <CalendarEventCellReminder eventInfo={eventInfo} />
      ) : (
        <CalendarEventCellEvent eventInfo={eventInfo} />
      )}
    </div>
  )
}
